// extracted by mini-css-extract-plugin
export default {"form":"style_form__dNlQ7","title":"style_title__dVrAv","text":"style_text__x4Thf","alreadyUser":"style_alreadyUser__ZdiLb"};